module.exports = __webpack_public_path__ + "static/media/muli-latin-700italic.af763a17.woff2";